import { useMemo, useRef } from 'react';
import { GlobalEventsContext } from './global-events-context';

export const GlobalEventsProvider = ({ children }) => {
  const curHookId = useRef(0);
  const eventHooks = useRef({});

  const addEventHook = (eventName, callback) => {
    curHookId.current = curHookId.current + 1;
    const hookId = curHookId.current;

    eventHooks.current[eventName] = [
      ...(eventHooks.current[eventName] ?? []),
      {
        id: hookId,
        callback: callback,
      },
    ];

    return hookId;
  };

  const removeEventHook = (eventName, hookId) => {
    if (eventHooks.current[eventName]) {
      eventHooks.current[eventName] = eventHooks.current[eventName].filter(
        (h) => h.id !== hookId
      );
    }
  };

  const triggerEvent = (eventName, eventData) => {
    if (eventHooks.current[eventName]) {
      for (const hook of eventHooks.current[eventName]) {
        hook.callback(eventData);
      }
    }
  };

  const api = useMemo(
    () => ({
      addEventHook,
      removeEventHook,
      triggerEvent,
    }),
    [addEventHook, removeEventHook, triggerEvent]
  );

  return (
    <GlobalEventsContext.Provider value={api}>
      {children}
    </GlobalEventsContext.Provider>
  );
};
